// extracted by mini-css-extract-plugin
module.exports = {"ManageCitiesDiv":"ManageCities_ManageCitiesDiv__2Ehvq","inputBox":"ManageCities_inputBox__2gPbU"};